'use client'

import {
  QueryClient,
  QueryClientProvider,
  HydrationBoundary,
  DehydratedState,
} from '@tanstack/react-query'
import { useState } from 'react'

export const ReactQueryClientProvider = ({
  children,
  dehydratedState,
}: {
  children: React.ReactNode
  dehydratedState: DehydratedState | null | undefined
}) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // With SSR, we usually want to set some default staleTime
            // above 0 to avoid refetching immediately on the client
            staleTime: 60 * 1000,
          },
        },
      }),
  )

  // @@TODO: Determine to use queryClient or queryClientRef: (reuse existing or create new)
  /*
  const [queryClient, setQueryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error) => {
            const errorTyped = error
            if (errorTyped) {
              logWrapper(`Something went wrong: ${errorTyped.message}`)
            }
          },
        }),
      }),
  )
*/

  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
    </QueryClientProvider>
  )
}
